import { useCallback } from 'react';
import dayjs from 'dayjs';

export const useDateFormatter = () => {
  return useCallback(
    (date) => (date ? dayjs(date).format('YYYY-MM-DDTHH:mm:ss') : null),
    []
  );
};
